"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
const react_uuid_1 = __importDefault(require("react-uuid"));
class User {
    //#region Methods, Attributes, Properties
    constructor() {
        this.storageKey = 'userid';
        this.userId = undefined;
        //#endregion Singleton Pattern
        //#region Public Methods
        this.setUserId = () => {
            // if userid didn't stored in localstorage, new value is generated by uuid() function.
            let id;
            id = localStorage.getItem(this.storageKey);
            if (!id) {
                id = (0, react_uuid_1.default)();
                localStorage.setItem(this.storageKey, id);
            }
            // Setting userid
            this.userId = id;
        };
        this.getUserId = () => {
            if (!this.userId) {
                this.setUserId();
            }
            return this.userId;
        };
        this.setUserId();
    }
}
exports.User = User;
User.getInstance = () => {
    if (!User.instance) {
        User.instance = new User();
    }
    return User.instance;
};
